export const X_READ_APP_LOCATION = "X-Read-App-Location";
export const X_READ_APP_USER_ID = "X-Read-App-User-Id";
export const X_READ_APP_INFO = "X-Read-App-Info";
